import React, { useCallback, useState } from 'react'

import { useIsMobile } from '~/hooks'
import type { IProduct } from '~/types/products'

import VariantsStockModal from './variants-stock-modal'
import VariantsStockPopover from './variants-stock-popover'

interface VariantsStockPopoverProps {
  variants: IProduct[]
  activeVariant?: IProduct
  variantsLabel: string
}

function VariantsStock({ variants, activeVariant, variantsLabel }: VariantsStockPopoverProps) {
  const [triggerElement, setTriggerElement] = useState<HTMLButtonElement | null>(null)

  const [isVisible, setIsVisible] = useState(false)

  const isMobile = useIsMobile()

  const onClose = useCallback(() => setIsVisible(false), [])

  const onToggle = useCallback(() => setIsVisible(prev => !prev), [])

  return (
    <>
      <button
        ref={setTriggerElement}
        type="button"
        onClick={onToggle}
        className="text-xs text-blue-600 underline hover:text-blue-800"
      >
        {variantsLabel}
      </button>
      {isVisible &&
        (isMobile ? (
          <VariantsStockModal variants={variants} activeVariant={activeVariant} onClose={onClose} />
        ) : (
          <VariantsStockPopover
            variants={variants}
            activeVariant={activeVariant}
            triggerElement={triggerElement}
            onClose={onClose}
          />
        ))}
    </>
  )
}

export default VariantsStock
